/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NewsFeedUnSeenResponse } from '../../models/news-feed-un-seen-response';

export interface CountOfUnseenNewsFeedItems$Params {
}

export function countOfUnseenNewsFeedItems(http: HttpClient, rootUrl: string, params?: CountOfUnseenNewsFeedItems$Params, context?: HttpContext): Observable<StrictHttpResponse<NewsFeedUnSeenResponse>> {
  const rb = new RequestBuilder(rootUrl, countOfUnseenNewsFeedItems.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NewsFeedUnSeenResponse>;
    })
  );
}

countOfUnseenNewsFeedItems.PATH = '/rest/user/newsfeed/unseen';
